import React from 'react'
import Text from '../Text'

const RewardsSection = ({ data }) => {
  const title = data?.title
  const description = data?.description
  const subTitle = data?.subTitle
  const image = data?.image
  const cards = Array.isArray(data?.cards) ? data.cards : []

  return (
    <section className="w-full bg-white">
      <div className="max-w-[1024px] mx-auto px-4">
        <div className="space-y-3">
          {title ? (
            <Text
              variant="headline"
              size="small"
              tag="p"
              className="text-primary-text"
            >
              {title}
            </Text>
          ) : null}

          <div className="flex gap-4 py-3">
            <img
              src={image}
              alt={title || 'Rewards'}
              className="w-[116px] h-[116px] object-scale-down"
            />
            <div className="flex flex-col gap-2">
              <Text
                variant="body"
                size="medium"
                tag="p"
                className="text-primary-text"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </div>
          </div>

          {subTitle ? (
            <Text
              variant="body"
              size="medium"
              tag="p"
              className="text-primary-text"
            >
              {subTitle}
            </Text>
          ) : null}
          {cards.length ? (
            <div className="pt-0 flex gap-4 overflow-x-auto no-scrollbar -mx-4">
              {cards.map((c, idx) => (
                <div
                  key={`reward-${idx}`}
                  className="rounded-xl bg-[linear-gradient(180deg,_#EEF4FF_0%,_#FFF_100%)] p-3 min-w-[140px] max-w-[140px] first:ml-4 last:mr-4 flex-1 gap-2 flex flex-col justify-between"
                >
                  {c?.icon ? (
                    <img
                      src={c.icon}
                      alt={c?.text}
                      className="w-6 h-6 object-scale-down"
                    />
                  ) : null}
                  <Text
                    variant="body"
                    size="medium"
                    tag="p"
                    className="text-primary-text"
                    dangerouslySetInnerHTML={{ __html: c?.text }}
                  />
                  {c?.coin?.value ? (
                    <div className="bg-[linear-gradient(90deg,_#299D6B_0%,_#FFFBEE_100%)] rounded-3xl max-w-fit">
                      <div className="flex items-center gap-1 shrink-0 bg-[linear-gradient(0deg,_#E6FAF1_0%,_#FFFBEE_100%)] px-2 py-1 m-[1.5px] rounded-3xl max-w-fit">
                        {c?.coin?.icon ? (
                          <img
                            src={c.coin.icon}
                            alt={c.coin.value}
                            className="w-[18px] h-[18px] object-contain"
                          />
                        ) : null}
                        <Text
                          variant="label"
                          size="small"
                          tag="p"
                          className="text-primary-text"
                          dangerouslySetInnerHTML={{ __html: c.coin.value }}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  )
}

export default RewardsSection
